<template>
	<div class="w-100">
		<div class="d-flex flex-row w-100">
			<div class="mr-4">
				<content-hover :user="idea.user" avatar/>
			</div>
			<div class="w-100">
				<div class="post-comment w-100" :class="{'comment-success': idea.is_solution}">
					<div class="flex-grow-1">
						<div class="post-comment-content">
							<div class="d-flex flex-row justify-content-between">
								<div v-if="idea.user">
									<content-hover :user="idea.user" user-name hover-class="bold"/>
									<div v-if="idea.user.job_position" class="text-muted font-12">{{ idea.user.job_position }}</div>
								</div>
								<post-dropdown
									v-if="validDropdownOptions.length && !simple"
									:options="validDropdownOptions"
								/>
							</div>
							<div v-if="!edition" class="mt-2">
								<multicontent v-if="!edition" :content="idea.content" :mentions="idea.mention_users" url-preview small class="mt-2"/>
							</div>
							<div v-else-if="!simple" class="d-flex">
								<content-editable-input
									v-model="ideaContent"
									emojis
									ref="content-editable-input"
									@enterPress="updateIdea"
									@escapePress="edition = false"
									class="d-flex flex-grow-1"
								/>
								<div class="ml-2">
									<v-btn depressed color="primary" class="h-100" @click="updateIdea">
										{{ $vuetify.lang.t('$vuetify.views.wall.post.update') }}
									</v-btn>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				<div v-if="!simple" class="d-flex mt-1 justify-content-between align-center">
					<div class="d-flex flex-row align-items-center">
							<post-comment-button
								:text="getReactionText()"
								:icon="myReactionIcon"
								ref="reactionButton"
								:id="'idea-reaction-button-' + _uid"
								:loading="saving.reaction"
								:action="() => setReaction()"
								:highlighted="reactionColor"
								@mouseenter.native="$refs.reactions.show()"
								@mouseleave=" $refs.reactions.hide()"
							/>
							<post-reaction-add
								ref="reactions"
								:attach="'idea-reaction-button-' + _uid"
								:problem-idea="idea"
								:nudge-top="40"
								:post-id="post.id"
							/>
						<template v-if="idea.reactions.length">

							<!--
							<post-details 
								:reactions="idea.reactions"
								class="ml-2"
							/>
							-->
						</template>
						<post-comment-button
							v-if="post.user.id == user.id"
							:loading="saving.solution"
							:text="idea.is_solution ? $vuetify.lang.t('$vuetify.views.wall.problem.actions.isSolution') : $vuetify.lang.t('$vuetify.views.wall.problem.actions.setAsSolution')"
							icon="$star"
							:action="() => setSolution()"
							:highlighted="idea.is_solution ? 'success--text' : false"
						/>
					</div>
					<div class="font-12 grey--text">
						{{ $moment(idea.created_at).fromNow() }}
					</div>
				</div>
				<div v-if="canManage && idea.is_solution && problem.status != 'resolved'" class="mt-1">
					<post-comment-button
						v-if="post.user.id == user.id"
						:text="$vuetify.lang.t('$vuetify.views.wall.problem.actions.addDescription')"
						icon="$help"
						ref="btn"
						:disabled="saving.solution || saving.finalSolution"
						:action="() => showFinalSolution = !showFinalSolution"
						:hightlighted="false"
						
					/>
					
					<v-form ref="solutionForm" @submit.prevent="setFinalSolution()" v-if="showFinalSolution" class="d-flex flex-row align-items-center my-3">
						<v-text-field
							v-model="solutionDescription"
							:placeholder="`${$vuetify.lang.t('$vuetify.description')}...`"
							outlined
							dense
							single-line
							hide-details
							:rules="[rules.required]"
							:disabled="saving.finalSolution"
							@keyup.esc="showFinalSolution = false"
						></v-text-field>
						<v-btn :loading="saving.finalSolution" depressed color="primary" class="py-5 ml-2" type="submit">
							{{ $vuetify.lang.t('$vuetify.save') }}
						</v-btn>
					</v-form>
				</div>
			</div>
		</div>
		<problem-idea-delete-dialog v-if="canManage && showConfirmDelete" :idea="idea" @closed="showConfirmDelete = false" @deleted="showConfirmDelete = false" />
		<report-abuse-dialog :problem-idea="idea" v-if="showReportAbuse" @closed="(showReportAbuse = false)" />
	</div>
</template>

<script>

// import PostDetails from '@/components/wall/post/PostDetails';
import { decodeMentions } from "@/functions/mentions";
import Multicontent from '@/components/items/Multicontent'
import ContentEditableInput from '@/components/items/ContentEditableInput';
import PostDropdown from "@/components/wall/post/PostDropdown";
const ProblemIdeaDeleteDialog = import("@/components/wall/post/problem/ProblemIdeaDeleteDialog.vue");
import {mapGetters} from 'vuex';
import PostCommentButton from "@/components/wall/post/PostCommentButton";
import PostReactionAdd from '@/components/wall/post/PostReactionAdd';
const ReportAbuseDialog = import("@/components/wall/dialogs/ReportAbuseDialog");
import ContentHover from "@/components/items/ContentHover";
export default {
	components: {

		// PostDetails,
		Multicontent,
		ContentEditableInput,
		PostDropdown,
		ProblemIdeaDeleteDialog: () => ({
			component: ProblemIdeaDeleteDialog,
		}),
		PostCommentButton,
		PostReactionAdd,
		ReportAbuseDialog: () => ({
			component: ReportAbuseDialog,
		}),
		ContentHover
	},
	props: {
		post: {
			type: Object,
			required: true
		},
		idea: {
			type: Object,
			required: true
		},
		simple: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showReportAbuse: false,
			saving: {
				reaction: false,
				solution: false,
				finalSolution: false
			},
			rules: {
				required: value => !!value || 'Pole wymagane.',
			},
			showFinalSolution: false,
			solutionDescription: '',
			showConfirmDelete: false,
			edition: false,
			ideaContent: {},
			dropdownOptions: [
				{
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.problem.actions.editIdea'),
					icon: '$edit',
					type: 'edit',
					display: false,
					action: async () => {
						this.ideaContent = {
							content: this.idea.content,
							mention_users: this.idea.mention_users
						}
						this.edition = true
					}
				},
				{
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.problem.actions.deleteIdea'),
					icon: '$message-off',
					type: 'remove',
					display: false,
					action: () => {
						this.showConfirmDelete = true
					}
				},
				{
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.reportAbuse'),
					icon: '$exclamation',
					type: 'abuse',
					display: false,
					action: () => {
						this.showReportAbuse = true;
					}
				},
			],
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
		validDropdownOptions() {
			return this.dropdownOptions.filter(x => x.display);
		},
		problem() {
			return this.post.postable;
		},
		canManage() {
			if(this.idea.user.id == this.user.id) {
				return true;
			}
			return false;
		},
		myReaction() {
			return this.idea.my_reaction;
		},
		myReactionIcon() {
			if(this.myReaction) {
				// $like, $heart-reaction, $face-reaction, $applause-reaction;
				if(this.myReaction.type == 'love') {
					return '$heart-reaction';
				}
				else if(this.myReaction.type == 'happy') {
					return '$face-reaction';
				}
				else if(this.myReaction.type == 'applause') {
					return '$applause-reaction';
				}
				return '$like'
			}
			return '$like';
		},
		reactionColor() {
			if(this.myReaction) {
				if(this.myReaction.type == 'like') {
					return 'success--text'
				}
				if(this.myReaction.type == 'love') {
					return 'red--text'
				}
				if(this.myReaction.type == 'happy') {
					return 'gold--text'
				}
				if(this.myReaction.type == 'applause') {
					return 'blue--text'
				}
			}
			return null;
			/*
					.post-reacted.reaction-like, .reaction-like {
		background: var(--v-success-lighten3) !important;
		.v-icon {
			color: var(--v-success-base);
		}
		&:hover {
			background: var(--v-success-lighten3) !important;
			.v-icon {
				color: var(--v-success-base) !important;
			}
		}
	}
	.post-reacted.reaction-love, .reaction-love {
		background-color: $reaction-love-bg !important;
		.v-icon {
			color: var(--v-warning-base)
		}
		&:hover {
			background: $reaction-love-bg !important;
			.v-icon {
				color: var(--v-warning-base) !important
			}
		}
	}
	.post-reacted.reaction-happy, .reaction-happy {
		background: $reaction-happy-bg !important;
		.v-icon {
			color: var(--v-gold-base)
		}
		&:hover {
			background: $reaction-happy-bg !important;
			.v-icon {
				color: var(--v-gold-base) !important;
			}
		}
	}
	.post-reacted.reaction-applause, .reaction-applause {
		background: $reaction-applause-bg !important;
		.v-icon {
			color: var(--v-blue-base)
		}
		&:hover {
			background: $reaction-applause-bg !important;
			.v-icon {
				color: var(--v-blue-base) !important;
			}
		}
	}
				*/
			
		}

	},
	methods: {
		getReactionText() {
			if(this.myReaction) {
				return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.' + this.myReaction.type)
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reaction')
			
		},
		checkManageAbility() {
			let idx1 = this.dropdownOptions.findIndex(x => x.type == 'edit') ;
			let idx2 = this.dropdownOptions.findIndex(x => x.type == 'remove');
			if(this.user.id == this.idea.user.id) {
				if(idx1 != -1) {
					this.dropdownOptions[idx1].display = true;
				}
				if(idx2 != -1) {
					this.dropdownOptions[idx2].display = true;
				}
			}
			else {
				if(idx1 != -1) {
					this.dropdownOptions[idx1].display = false;
				}
				if(idx2 != -1) {
					this.dropdownOptions[idx2].display = false;
				}
			}
		},
		checkReportAbuseAbility() {
			let idx = this.dropdownOptions.findIndex(o => o.type === 'abuse');
			if(idx != -1) {
				if(this.user.id != this.idea.user.id) {
					this.dropdownOptions[idx].display = true;
				}
				else {
					this.dropdownOptions[idx].display = false;
				}
			}
		},
		async setFinalSolution() {
			const valid = this.$refs.solutionForm.validate();
			if(valid) {
				this.saving.finalSolution = true;
				const res = await this.$store.dispatch('wall/updateProblemPost', {
					id: this.post.id,
					problem: {
						status: 'resolved',
						solution: this.solutionDescription
					}
				});
				if(res.success) {
					await this.$store.dispatch('wall/changeProblemStatus', {
						postId: this.post.id,
						status: 'resolved'
					});
					
				}
				this.showFinalSolution = false;
				this.saving.finalSolution = false;
			}
		},
		async setSolution() {
			// api/posts/problem/idea/{problemIdea}/update-is-solution
			this.saving.solution = true;
			let isSolution = !this.idea.is_solution;
			const res = await this.$store.dispatch('wall/setProblemIdeaAsSolution', {id: this.idea.id, is_solution: isSolution});
			if(res.success) {
				console.log("SUCCESS!", res)
			}

			const solutions = this.problem.problem_ideas.filter(x => x.is_solution);
			let newStatus = null;
			if(!solutions.length) {
				newStatus = 'analyzed';
			}
			else {
				newStatus = 'in_progress';
			}
			if(newStatus != this.problem.status) {
				await this.$store.dispatch('wall/changeProblemStatus', {
					postId: this.post.id,
					status: newStatus
				});
			}
			
			this.saving.solution = false;
		},
		async updateIdea() {
			let res = await this.$store.dispatch('wall/editProblemIdea', {
				id: this.idea.id,
				content: this.ideaContent.content,
				mention_user_ids: this.ideaContent.mentions
			})
			if(res.success) {
				this.edition = false;
			}
		},
		checkMentions(val, users) {
			return decodeMentions(val, users)
		},
		async setReaction() {
			if (this.saving.reaction) {
				return null
			}
			let postID = this.post.id, type = 'like', problemIdeaId = this.idea.id
			this.saving.reaction = true
			if (this.myReaction) {
				let id = this.myReaction.id,
					reactionID = this.myReaction.id;

				const res = await this.$store.dispatch('wall/removeReaction', { id });
				console.log("RESSSS", res)
				if (res) {
					console.log("SHOULD REMOVE")
					this.$store.commit('wall/removeReactionFromProblemIdea',{ postID, problemIdeaId, reactionID })
				}
					
			} 
			else {
				let reactionable_type = 'problemIdea',
					reactionable_id = this.idea.id,
					reaction = await this.$store.dispatch('wall/setReaction', { type, reactionable_type, reactionable_id });
					console.log("REACTION", reaction)

					this.$store.commit('wall/appendReactionToProblemIdea', { postID, problemIdeaId, reaction })
			}
			this.saving.reaction = false
		}
	},
	created() {
		this.checkManageAbility();
		this.checkReportAbuseAbility();
	}
}
</script>

